export interface boat {
    id: string
    title: string
    description: string
    img: string
    buttonText: string
}
export interface listBoat {
    id: string
    title: string
    price: string
    description: string
    img: string
    code?: string,
    values: boat[]
}

export const BoatList: listBoat[] = [
    // {
    //     id: 'Sunspree',
    //     title: 'Sunspree',
    //     code: 'SP220',
    //     description: 'There are many ways to enjoy your time on the water. The Sunspree model offers the flexibility you need to enjoy them all.',
    //     price: 'STARTING AT $29,150',
    //     img: '/img/listBoat/Sunspree/main.jpg',
    //     values: [
    //         {
    //             id: 'Sunspree_RF_230_CL',
    //             title: 'Sunspree RF 230 CL',
    //             description: ' Featuring convenient, functional amenities and refined, supple fabrics, the Intrigue is a sophisticated watercraft designed to turn heads.                                            ',
    //             img: '/img/listBoat/Sunspree/Sunspree_RF_230_CL.jpg',
    //             buttonText: 'Build your boat',
    //         },
    //     ]
    // },
    {
        id: 'Sunsation',
        title: 'Sunsation',
        code: 'SS200',
        description: 'Our best-selling model, the Sunsation is a highly adaptable and flexible watercraft that adjusts to whatever you have in mind. This model offers an extremely popular layout with plenty of seating for everyone aboard.',
        price: 'STARTING AT $34,850',
        img: '/img/listBoat/Sunsation/main.jpg',
        values: [
            // {
            //     id: 'Sunsation_RC_230_DL',
            //     title: 'SUNSATION RC 230 DL',
            //     description: ' Featuring convenient, functional amenities and refined, supple fabrics, the Intrigue is a sophisticated watercraft designed to turn heads.',
            //     img: '/img/listBoat/Sunsation/Sunsation_RC_230_DL.jpg',
            //     buttonText: 'Build your boat',
            // },
            {
                id: 'Sunsation_RL_230_CL',
                title: 'Sunsation RL 230 CL',
                description: ' Featuring convenient, functional amenities and refined, supple fabrics, the Intrigue is a sophisticated watercraft designed to turn heads.',
                img: '/img/listBoat/Sunsation/Sunsation_RL_230_CL.jpg',
                buttonText: 'Build your boat',
            },

        ]
    },
    {
        id: 'Solaris',
        title: 'Solaris',
        code: 'SL230',
        description: 'The Solaris is made to create a lifetime of memories for your whole family. Combining luxury and technology; this model is equipped with all the extras.',
        price: 'STARTING AT $53,333',
        img: '/img/listBoat/Solaris/main.jpg',
        values: [
            {
                id: 'Solaris_REV_250_CL',
                title: 'Solaris REV 250 CL',
                description: ' Featuring convenient, functional amenities and refined, supple fabrics, the Intrigue is a sophisticated watercraft designed to turn heads.',
                img: '/img/listBoat/Solaris/Solaris REV 250 CL.jpg',
                buttonText: 'Build your boat',
            },

        ]
    },
    {
        id: 'Intrigue',
        title: 'Intrigue',
        code: 'IN230',
        description: 'From bow to stern, this model is built with a high standard of excellence. Equipped with convenient, functional amenities and refine, supple fabrics the Intrigue is a sophisticated watercraft designed to turn heads.',
        price: 'STARTING AT $84,183',
        img: '/img/listBoat/Intrigue/main.jpg',
        values: [
            // {
            //     id: 'intrigue-rf-250-cl',
            //     title: 'Intrigue RF 250 CL',
            //     description: ' Featuring convenient, functional amenities and refined, supple fabrics, the Intrigue is a sophisticated watercraft designed to turn heads.',
            //     img: '/img/listBoat/Intrigue/Intrigue_RF_250_CL.jpg',
            //     buttonText: 'Build your boat',
            // },
            {
                id: 'intrigue-rl-230-cl',
                title: 'INTRIGUE RL 230 CL',
                description: ' Featuring convenient, functional amenities and refined, supple fabrics, the Intrigue is a sophisticated watercraft designed to turn heads.',
                img: '/img/listBoat/Intrigue/Intrigue_RL_230_CL.jpg',
                buttonText: 'Build your boat',
            },
            // {
            //     id: 'Intrigue_Rev_270_CL',
            //     title: 'Intrigue REV 270 CL',
            //     description: ' Featuring convenient, functional amenities and refined, supple fabrics, the Intrigue is a sophisticated watercraft designed to turn heads.',
            //     img: '/img/listBoat/Intrigue/Intrigue_Rev_270_CL.jpg',
            //     buttonText: 'Build your boat',
            // },


        ]
    },
    {
        id: 'Escalante',
        title: 'Escalante',
        description: "With the quality of attention to detail that you only find on a Premier, the Escalante delivers an unmatched experience that is a step above the rest. The Escalante features a 10'wide floor plan, hard-sided changing room, and pub-style booth. The centerpiece of the Escalante is its walk-up Step Galley staircase.",
        price: 'STARTING AT $153,450',
        img: '/img/listBoat/Escalante/main.jpg',
        values: [
            {
                id: 'Escalante_310_CL',
                title: 'Escalante 310 CL',
                description: ' Featuring convenient, functional amenities and refined, supple fabrics, the Intrigue is a sophisticated watercraft designed to turn heads.',
                img: '/img/listBoat/Escalante/Escalante_310_CL.jpg',
                buttonText: 'Build your boat',
            },
        ]
    },
    // {
    //     id: 'Accolade',
    //     title: 'Accolade',
    //     description: "There's no better place to live it up than on the entertainment oasis, the Accolade. A roomy 10'-wide floor plan with a walk-through horseshoe-shaped bar. This model is the perfect combination of innovative technology and luxury features that Premier is known for.",
    //     price: 'STARTING AT $116,283',
    //     img: '/img/listBoat/Accolade/main.jpg',
    //     values: [
    //         {
    //             id: 'Accolade_310_CL',
    //             title: 'Accolade 310 CL',
    //             description: "Featuring convenient, functional amenities and refined, supple fabrics, the Intrigue is a sophisticated watercraft designed to turn heads.",
    //             img: '/img/listBoat/Accolade/Accolade_310_CL.jpg',
    //             buttonText: 'Build your boat',
    //         },
    //     ]
    // },
    // {
    //     id: 'Grand_Entertainer',
    //     title: 'Grand Entertainer',
    //     description: "Entertainment is a breeze on the Grand Entertainer. Find the perfect gathering place for friends and family at the Entertainer Bar where many memories will be made to last.",
    //     price: 'STARTING AT $84,633',
    //     img: '/img/listBoat/Grand_Entertainer/main.jpg',
    //     values: [
    //         {
    //             id: 'Grand_Entertainer_250',
    //             title: 'Grand Entertainer 250 CL',
    //             description: ' Featuring convenient, functional amenities and refined, supple fabrics, the Intrigue is a sophisticated watercraft designed to turn heads.',
    //             img: '/img/listBoat/Grand_Entertainer/Grand_Entertainer_250.jpg',
    //             buttonText: 'Build your boat',
    //         },
    //     ]
    // },

    // {
    //     id: 'Grand_View',
    //     title: 'Grand View',
    //     description: "Cruise with a different perspective. The Grand View features a unique raised platform that elevates the driver's experience. With steps both in the bow and aft; this model effectively utilizes the space below with a large storage compartment. Climb aboard and see for yourself what the Grand View is all about.",
    //     price: 'STARTING AT $82,933',
    //     img: '/img/listBoat/Grand_View/main.jpg',
    //     values: [
    //         {
    //             id: 'Grand_View_290_DL',
    //             title: 'Grand View 290 DL',
    //             description: ' Featuring convenient, functional amenities and refined, supple fabrics, the Intrigue is a sophisticated watercraft designed to turn heads.',
    //             img: '/img/listBoat/Grand_View/Grand_View_290_DL.jpg',
    //             buttonText: 'Build your boat',
    //         },

    //     ]
    // },
   
    // {
    //     id: 'Boundary_Waters',
    //     title: 'Boundary Waters',
    //     description: 'Mixing classic necessities and luxury finish for more than two decades. Experience the limitless style and signature features that the Boundary Waters model offers.',
    //     price: 'STARTING AT $99,233',
    //     img: '/img/listBoat/Boundary_Waters/main.jpg',
    //     values: [
    //         {
    //             id: 'Boundary_Waters_250_CL',
    //             title: 'Boundary Waters 250 CL',
    //             description: 'Featuring convenient, functional amenities and refined, supple fabrics, the Intrigue is a sophisticated watercraft designed to turn heads.',
    //             img: '/img/listBoat/Boundary_Waters/Boundary_Waters_250_CL.jpg',
    //             buttonText: 'Build your boat',
    //         },
    //         {
    //             id: 'Boundary_Waters_REV_WALK_ON_310_CL',
    //             title: 'Boundary Waters REV WALK ON 310 CL',
    //             description: 'Featuring convenient, functional amenities and refined, supple fabrics, the Intrigue is a sophisticated watercraft designed to turn heads.',
    //             img: '/img/listBoat/Boundary_Waters/Boundary_Waters-REV_WALK_ON_310_CL.jpg',
    //             buttonText: 'Build your boat',
    //         },

    //     ]
    // },
    
    // {
    //     id: 'Grand_Majestic',
    //     title: 'Grand Majestic',
    //     description: "Enjoy the majesty of nature in a craft inspired by the beauty of being outdoors with family and friends. The Grand Majestic with our PTX technology combine for the perfect blend of speed, maneuverability and comfort.",
    //     price: 'STARTING AT $72,467',
    //     img: '/img/listBoat/Grand_View/main.jpg',
    //     values: [
    //         {
    //             id: 'Grand_Majestic_RE_250_CL',
    //             title: 'Grand Majestic RE 250 CL',
    //             description: ' Featuring convenient, functional amenities and refined, supple fabrics, the Intrigue is a sophisticated watercraft designed to turn heads.',
    //             img: '/img/listBoat/Grand_Majestic/Grand_Majestic_RE_250_CL.jpg',
    //             buttonText: 'Build your boat',
    //         },

    //     ]
    // },
    // {
    //     id: 'S_Series',
    //     title: 'S-Series',
    //     description: 'The S-Series model delivers high style balanced with power and performance. Equipped with a 36" PTX package and dual console layout that features a new windshield design to provide all-weather protection and comfort. This model performs seamlessly on the water. ',
    //     price: 'STARTING AT $67,200',
    //     img: '/img/listBoat/S_Series/main.jpg',
    //     values: [
    //         {
    //             id: 'S_Series_250_CL',
    //             title: 'S Series 250 CL',
    //             description: ' Featuring convenient, functional amenities and refined, supple fabrics, the Intrigue is a sophisticated watercraft designed to turn heads.',
    //             img: '/img/listBoat/S_Series/S_Series_250_CL.jpg',
    //             buttonText: 'Build your boat',
    //         },
    //     ]
    // },
    
    
   
    // {
    //     id: 'Castaway',
    //     title: 'Castaway',
    //     code: 'CAW220',
    //     description: '360 degrees of accessible fishing; there are no limits fishing aboard the Castaway. Highlighting four premium fishing spots, two live wells, a rod locker, and 3-in-1 active imaging transducer. This model is perfect for reeling in good times and even the catch of the day!',
    //     price: 'STARTING AT $55,900',
    //     img: '/img/listBoat/Castaway/main.jpg',
    //     values: [
    //         {
    //             id: 'Castaway_250_CL',
    //             title: 'Castaway 250 CL',
    //             description: ' Featuring convenient, functional amenities and refined, supple fabrics, the Intrigue is a sophisticated watercraft designed to turn heads.',
    //             img: '/img/listBoat/Castaway/Castaway_250_CL.jpg',
    //             buttonText: 'Build your boat',
    //         },

    //     ]
    // },
    
    




]